/** Opens the newsletter pop-up once per visitor, a few seconds after the page loads. */
const popup = document.querySelector('[data-newsletter-popup]');

if (popup) {
  const key = 'knutten-newsletter-popup';
  const seen = () => {
    try {
      return localStorage.getItem(key) !== null;
    } catch {
      return false;
    }
  };
  const remember = () => {
    try {
      localStorage.setItem(key, '1');
    } catch {
      // Without storage the pop-up simply shows again on a next visit.
    }
  };
  const open = () => {
    if (!popup.open && !document.querySelector('dialog[open]')) popup.showModal();
  };

  popup.addEventListener('close', remember);
  popup.addEventListener('submit', remember);
  popup.addEventListener('click', (event) => {
    if (event.target === popup) popup.close();
  });

  // In the theme editor, show the pop-up while its section is selected.
  const section = popup.closest('.shopify-section');
  section.addEventListener('shopify:section:select', open);
  section.addEventListener('shopify:section:deselect', () => popup.close());

  const posted = popup.querySelector('.newsletter-form__success');
  const postedInPage = document.querySelector('.newsletter .newsletter-form__success');

  if (posted && !postedInPage) {
    // Back from signing up through the pop-up: show the confirmation.
    open();
  } else if (!posted && !seen() && !window.Shopify?.designMode) {
    setTimeout(open, Number(popup.dataset.delay) * 1000);
  }
}
